import { atom } from 'recoil';

export const branchState = atom<string[]>({
  key: 'global-selected-branch', // unique ID
  default: [],
});
